export default "__VITE_ASSET__afe02be0__"